//滑动组件
//targetElem 目标元素
function smoothjump(targetElem) {
  const nowScroll = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop //考虑浏览器兼容性
  const targetScroll = targetElem.getBoundingClientRect().top + nowScroll
  let fn = (nowScroll,needScroll) => {
    setTimeout(() => {
      const step = Math.ceil(needScroll / 20)
      const _currentY = nowScroll + step
      if (Math.abs(step) > 5  ) {
        window.scroll(0, _currentY)
        fn(_currentY, targetScroll - _currentY)
      } else {
        window.scroll(0, targetScroll)
      }
    }, 2)
  }
  fn(nowScroll,targetElem.getBoundingClientRect().top)
}